import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {Pageable} from "@app/_model";
import {environment} from "@environments/environment";
import {AbstractControl, ValidatorFn} from "@angular/forms";
import {AccountClientType} from "@app/_model/account.client";
import {Logger} from "@app/logger";

export class Util {

  private static readonly log = new Logger();

  private constructor() {
  }

  public static isEmpty(obj: any) {
    return obj === undefined
      || obj === null
      || (typeof (obj) === 'number' && Number.isNaN(obj))
      || (typeof (obj) === 'string' && obj === '')
      || (typeof (obj) === 'object' && Object.keys(obj).length === 0);
  }

  public static isApiUrl(url: string): boolean {
    return url.startsWith(environment.apiUrl);
  }

  public static table2pageable(paginator: MatPaginator, sort: MatSort): Pageable {
    return new Pageable(paginator.pageIndex, paginator.pageSize, sort.active, sort.direction);
  }

  public static fixPaginatorOverload(paginator: MatPaginator, dataCount: number): void {
    const pageIndex = paginator.pageIndex;
    const pageSize = paginator.pageSize;
    const maxPageIndex = Math.max(Math.ceil(dataCount / pageSize) - 1, 0);
    if (pageIndex < 0) {
      Util.log.warn("paginatorOverload: pageIndex (" + pageIndex + ") < 0");
      paginator.pageIndex = 0;
    } else if (pageIndex > maxPageIndex) {
      Util.log.info("paginatorOverload: pageIndex (" + pageIndex + ") > maxPageIndex (" + maxPageIndex + ")");
      paginator.pageIndex = maxPageIndex;
    } else {
      return;
    }
    paginator._changePageSize(pageSize);
  }

  public static mailToLink(email: string): string {
    return "mailto:" + email;
  }

  public static displayAccountClientType(accountClientType: AccountClientType): string {
    return accountClientType.toLowerCase();
  }

  public static matchValidator(controlName: string, matchingControlName: string, errorKey: string, errorMessage: string): ValidatorFn {
    return (abstractControl: AbstractControl) => {
      const control = abstractControl.get(controlName);
      const matchingControl = abstractControl.get(matchingControlName);
      if (matchingControl!.errors && !matchingControl!.errors?.[errorKey]) {
        return null;
      }
      if (control!.value !== matchingControl!.value) {
        const error = { [errorKey]: errorMessage };
        matchingControl!.setErrors(error);
        return error;
      } else {
        matchingControl!.setErrors(null);
        return null;
      }
    }
  }

  public static ldapDNValidator(): ValidatorFn {
    const elementRegex = /^([a-zA-Z]+)=([a-zA-Z0-9_\-.]+)$/;
    return (abstractControl: AbstractControl) => {
      const value = abstractControl.value;
      if (!value) {
        return null;
      }
      if (typeof value !== 'string') {
        return { ldapDNValidator: true };
      }
      const parts = value.split(',');
      const valid = parts.every(p => elementRegex.test(p));
      return valid ? null : { ldapDNValidator: true };
    }
  }
}
